<template>
  <div class="text-center text-black">
    <div>
      <form id="form">
        <div class="grid max-w-3x1 gap-1 px-1 sm:grid-cols-2 bg-white">
          <div class="grid">
            Nombre
            <div
              class="bg-white flex min-h-[60px] flex-col-reverse justify-center rounded-md border border-gray-300 px-3 py-2 shadow-sm focus-within:shadow-inner"
            >
              <input
                type="text"
                v-model="nombre"
                name="name"
                id="nombre"
                class="peer block w-full border-0 p-0 text-base text-gray-900 placeholder-gray-400 focus:ring-0"
                placeholder="Ejemplo: Andrés Felipe Medina"
                required
              />
              <!-- <label
              html="first-name"
              class="block transform text-xs font-bold uppercase text-gray-400 transition-opacity, duration-200 peer-placeholder-shown:h-0 peer-placeholder-shown:-translate-y-full peer-placeholder-shown:opacity-0"
            ></label> -->
            </div>
          </div>
          <div class="grid">
            Correo
            <div
              class="bg-white first:flex min-h-[60px] flex-col-reverse justify-center rounded-md border border-gray-300 px-3 py-2 shadow-sm focus-within:shadow-inner"
            >
              <input
                type="text"
                name="email"
                id="last-name"
                class="peer block w-full border-0 p-0 text-base text-gray-900 placeholder-gray-400 focus:ring-0"
                placeholder="Ejemplo:andres@gmail.com"
                required
              />
              <!-- <label
              html="last-name"
              class="block transform text-xs font-bold uppercase text-gray-400 transition-opacity, duration-200 peer-placeholder-shown:h-0 peer-placeholder-shown:-translate-y-full peer-placeholder-shown:opacity-0"
            ></label> -->
            </div>
          </div>
          <div class="grid">
            Celular
            <div
              class="bg-white flex min-h-[60px] flex-col-reverse justify-center rounded-md border border-gray-300 px-3 py-2 shadow-sm focus-within:shadow-inner"
            >
              <input
                type="text"
                name="phone"
                id="last-name"
                class="peer block w-full border-0 p-0 text-base text-gray-900 placeholder-gray-400 focus:ring-0"
                placeholder="Ejemplo:839 317 5834"
                required
              />
              <!-- <label
              html="company"
              class="block transform text-xs font-bold uppercase text-gray-400 transition-opacity, duration-200 peer-placeholder-shown:h-0 peer-placeholder-shown:-translate-y-full peer-placeholder-shown:opacity-0"
              >Company</label
            > -->
            </div>
          </div>
          <div class="grid">
            Dirección
            <div
              class="bg-white flex min-h-[60px] flex-col-reverse justify-center rounded-md border border-gray-300 px-3 py-2 shadow-sm focus-within:shadow-inner"
            >
              <input
                type="name"
                name="address"
                id="address"
                class="peer block w-full border-0 p-0 text-base text-gray-900 placeholder-gray-400 focus:ring-0"
                placeholder="Calle20 #13-64"
                required
              />
              <!-- <label
              html="email"
              class="block transform text-xs font-bold uppercase text-gray-400 transition-opacity, duration-200 peer-placeholder-shown:h-0 peer-placeholder-shown:-translate-y-full peer-placeholder-shown:opacity-0"
              >E-mail</label
            > -->
            </div>
          </div>
          <div class="grid">
            Mensaje
            <div
              class="bg-white flex min-h-[60px] flex-col-reverse justify-center rounded-md border border-gray-300 px-3 py-2 shadow-sm focus-within:shadow-inner"
            >
              <textarea
                type="text"
                name=""
                id="text"
                class="peer block w-full border-0 p-0 text-base text-gray-900 placeholder-gray-400 focus:ring-0"
                placeholder="Describa el motivo de su cita"
                required
              />
              <!-- <label
              html="email"
              class="block transform text-xs font-bold uppercase text-gray-400 transition-opacity, duration-200 peer-placeholder-shown:h-0 peer-placeholder-shown:-translate-y-full peer-placeholder-shown:opacity-0"
              >E</label
            > -->
            </div>
          </div>
        </div>
        <input type="checkbox" name="check" required /> Acepto Terminos,
        Condiciones y Políticas de Privacidad.
        <br />
        <button
          type="submit"
          @click="enviarFormulario"
          class="mt-4 bg-orange-500 text-white py-2 px-6 rounded-md hover:bg-orange-600"
        >
          Enviar
        </button>
      </form>
    </div>
    <!-- Mensaje de confirmación -->
    <div v-if="formularioEnviado" class="mt-4 text-green-500">
      ¡El formulario ha sido enviado con éxito!
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      nombre: "",
      email: "",
      phone: "",
      address: "",
      message: "",
      acceptedTerms: false,
    };
  },
  methods: {
    enviarFormulario() {
      // Paso 1: Validación de los datos del formulario
      if (!this.validarFormulario()) {
        // Si la validación falla, puedes mostrar un mensaje de error o realizar alguna acción específica.
        return;
      }

      // Paso 2: Envío de los datos del formulario (puedes usar Axios, Fetch, etc.)
      const formData = {
        nombre: this.nombre,
        email: this.email,
        phone: this.phone,
        address: this.address,
        message: this.message,
        acceptedTerms: this.acceptedTerms,
      };

      // Ejemplo de envío de datos utilizando Fetch API
      ("URL_DEL_SERVIDOR",
      {
        method: "POST", // Puedes cambiar el método según tus necesidades
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
        .then((response) => {
          if (response.ok) {
            // La solicitud se realizó correctamente, puedes mostrar un mensaje de éxito o redirigir al usuario a una página de confirmación.
          } else {
            // Si la solicitud falla, puedes manejar el error de alguna manera.
          }
        })
        .catch((error) => {
          // Manejo de errores de red u otros errores
        });
    },

    // Función de validación del formulario
    validarFormulario() {
      // Inicializamos una variable para rastrear si la validación ha tenido éxito.
      let esValido = true;

      // Verificamos si el campo 'nombre' está vacío.
      if (this.nombre.trim() === "") {
        esValido = false;
        // Puedes mostrar un mensaje de error o realizar otra acción específica.
      }

      // Verificamos si el campo 'email' es un correo electrónico válido.
      if (!this.validarEmail(this.email)) {
        esValido = false;
        // Puedes mostrar un mensaje de error o realizar otra acción específica.
      }

      // Verificamos si el usuario ha aceptado los términos y condiciones.
      if (!this.acceptedTerms) {
        esValido = false;
        // Puedes mostrar un mensaje de error o realizar otra acción específica.
      }

      // Devolvemos true si la validación es exitosa, de lo contrario, false.
      return esValido;
    },

    validarEmail(email) {
      // Utilizamos una expresión regular para validar el formato de correo electrónico.
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return regex.test(email);
    },
  },
};
</script>
